import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { InventoryBeHeadingDashboardDto } from "./inventory-beheading-dashboard.dto";

export class InventoryBeheadingDashboardResponse extends GlobalResponseObject{
    data?: InventoryBeHeadingDashboardDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: InventoryBeHeadingDashboardDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }

}